<script>
  import { handleSiteProvider } from '$lib/utils';

  let isBannerVisible = false;

  const onScroll = () => {
    if (window.scrollY === 0) {
      isBannerVisible = false;
      return;
    }
    isBannerVisible = true;
  };
</script>

<svelte:window on:scroll={onScroll} />

{#if !handleSiteProvider()}
  <section class={isBannerVisible ? 'sticky-container' : 'sticky-container hidden'}>
    <slot />
  </section>
{/if}

<style>
  .sticky-container {
    z-index: 2;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: var(--color-page-background);
    padding: 5px 0px 0px 0px;
    transform: translateX(0);
    opacity: 1;
    transition:
      transform 0.5s ease-out,
      opacity 0.5s ease-out; /* Adjust duration as needed */
  }

  .sticky-container.hidden {
    transform: translateY(100%); /* Adjust direction as needed */
    opacity: 0;
  }
</style>
